'use strict';

angular.module('app')
    .controller('LiveaboardCtrl', function ($scope, $location,gettextCatalog, $rootScope, $timeout, $routeParams, info, item, config, Search, Liveaboard, DiveOperator, Request, Destinations, utils, GTM, diviacLocalStorage, localStorageService) {
        var vm = this,
            liveaboard = new Liveaboard(item);
            

            console.log(gettextCatalog.getString("Diving"));


        vm.utils = utils;
        vm.shopSlug = $routeParams.slug;
        vm.bannerExclusions = info.bannerExclusions;
        vm.getProducts = liveaboard.getProducts;
        vm.showSelectedTrip = showSelectedTrip;
        vm.setSelectedItem = setSelectedItem;
        vm.clearFilters = clearFilters;
        vm.getItineraryLink = getItineraryLink;
        vm.showAllTrips = showAllTrips;
        vm.checkPreviousTrips = checkPreviousTrips;
        vm.showTrips = showTrips;
        vm.liveaboardFilter = {is_promotion:null};
        vm.triggerWishlist = DiveOperator.triggerWishlist;
        vm.triggerWishlistOperators = DiveOperator.triggerWishlistOperators;
        vm.startCheckout = startCheckout;
        vm.submitReview = DiveOperator.submitReview;
        vm.generateUrl = Search.generateUrl;
        vm.checkButtonInit = checkButtonInit;
        vm.getMoreReviews = getMoreReviews;
        vm.getTrips = getTrips;
        vm.setItinerary = setItinerary;
        vm.responsive = config.slickResponsive;
        vm.allReviews = [];
        vm.priceFilter = [];
        vm.setLocalStorageDate = setLocalStorageDate;
        vm.generateSearchLink = generateSearchLink;


        //FLASH SALE
        // if (sessionStorage.getItem('promotionStart')) {
        //     promotionDateStart = sessionStorage.getItem('promotionStart');
        // }

        vm.abTest2 = localStorageService.get('checkoutTest2');

        if (!_.isBoolean(vm.abTest2)) {
            vm.abTest2 = utils.randomRange(1,2) === 1;

            localStorageService.set('checkoutTest2',vm.abTest2);
        }

        GTM.variables({'user_experiment_1': vm.abTest2 ? "Cabin CTA: Select Cabin" : "Cabin CTA: Select"});

        window.isDateInRange= utils.isDateInRange;
        init();

        function init() {
            angular.extend(vm, liveaboard);

            if ($location.search().itinerarySlug) {
                $location.path($location.path() + $location.search().itinerarySlug);
                $location.search('');
                return true;
            }

            liveaboard.setLiveaboardAsViewed()
                .setMainGTM()
                .setAvailableDates(function (dates){
                    vm.dates = dates;
                })
                .getPhotos(function (data) {
                    angular.extend(vm, data);
                }).setDate();

            vm.durations = _.cloneDeep(vm.info.itinerariesLength);
            vm.filterDate = liveaboard._data.filterDate || null;
            $scope.haveProducts = vm.haveProducts;

            DiveOperator.getVideos().then(function (data) {
                vm.videos = data;
            });

            DiveOperator.itineraries($scope).then(function(pins) {
                vm.itineraries = pins.itineraries;
            });

            DiveOperator.getRooms({}).then(function(data) {
                vm.rooms = data;
            });

            var divingParams = _.find(vm.info.divingParameters, {
                    group: 140
                }),
                divingServices = _.find(vm.info.parameters, {
                    group: 70
                });

            if (divingParams) {
                _.each(divingParams.parameters, function (val) {
                    if (val === 'Nitrox (FREE)' || val === 'Nitrox ($)') {
                        vm.info.nitrox = val === 'Nitrox (FREE)' ? "FREE" : "YES ($)";
                    }

                    if (val === 'Rental Equipment (FREE)' || val === 'Rental Equipment ($)') {
                        vm.info.rental =  val === 'Rental Equipment (FREE)' ? "FREE" : "YES ($)";
                    }

                });
            }

            if (divingServices) {
                _.each(divingServices.parameters, function (val) {
                    if (val === 'Wi-Fi (FREE)' || val === 'Wi-Fi ($)') {
                        vm.info.wifi = val === 'Wi-Fi (FREE)' ? "FREE" : "YES ($)";
                    }
                });
            }

            DiveOperator.getShopPromotion().then(function (data) {
                vm.promotions = data;
            });


            DiveOperator.getScubaTribeReviews().then(function (data) {
               vm.scubaTribe = data;
               console.log(vm.scubaTribe);
            });

            DiveOperator.reviews(10).then(function(rating) {
                vm.reviews = rating;
                console.log(vm.reviews);

                GTM.variables({
                    operator_reviews_number: rating.numberOfReviews,
                    operator_rating_number: rating.numberOfReviews
                });

                _.map(rating.data.results, function(val) {
                    vm.allReviews.push(val);
                });

                vm.checkButtonInit();
            });

            _.each(vm.info.allowedPriceRanges, function(val, key){
                vm.priceFilter.push({id: key, from: val.from, to: val.to});
            });

            DiveOperator.getHighlights($scope).then(function(res) {
                vm.highlights = res.data;

                $scope.highlightsMarkers = res.pins;

                DiveOperator.getResorts($scope, vm.info).then(function(data) {
                    var pins = _.clone($scope.highlightsMarkers);
                    $scope.hlWithResorts = pins.concat(data.pins);
                    $scope.hlWithResorts = $scope.hlWithResorts.concat(data.shopPin);
                });
            });

            Destinations.getInfo(vm.info.countrySlug).then(function(val) {
                vm.country = val;
            });

            Destinations.getMarineLife('country').then(function(data) {
                $scope.marineLife = data;
                vm.marineLife = data;
                $scope.monthes = config.months;
            });

            DiveOperator.getOtherDiveoperators().then(function(operators) {
                vm.otherDiveOperatorsList = operators;

                var ecommerce = {
                    currencyCode: "USD",
                    impressions: []
                };
                
                _.each(operators, function(val, key) {
                    ecommerce.impressions.push({
                        name: val.title,
                        id: val.id,
                        brand: val.fleetTitle,
                        price: val.priceMin,
                        list: "Other",
                        position: key + 1
                    });
                });

                GTM.products(null, ecommerce);
            });

            GTM.variables({
                operator_slug: $routeParams.slug,
                operator_country_slug: vm.info.countrySlug
            });

        }


        // GET PRODUCT ONLY IF WE HAVE IT ON CURRENT DIVE OPERATOR
        if (vm.info && vm.info.productsCount && $location.search().itineraryId) {
            showSelectedTrip({
                id: $location.search().itineraryId
            });
            $location.search('');
        } else if (vm.info && vm.info.productsCount && !$location.search().itineraryId) {
            if ($location.search().duration) {
                var duration = [];
                _.each(vm.info.itinerariesLength, function (val) {
                    if (_.find($location.search().duration, function (v) {
                            return +v === val.id;
                        })) {
                        val.checked = true;
                        duration.push(val.id);
                    }
                });

                if (!vm.filterDate) {
                    vm.filterDate = {};
                }

                vm.liveaboardFilter.duration = duration;
                vm.filterDate.numberOfProducts = null;

                vm.getProducts(vm.filterDate, null, {duration: duration});
                $location.search('duration', null);
            } else {
                if($location.search().trip_id && $location.search().trip_date) {
                     var date = moment($location.search().trip_date).locale('en');
                     vm.filterDate = {
                         month: date.format('MMMM'),
                         year: date.format('YYYY'),
                         startDate: date.format('YYYY-MM-DD')
                     };
                     vm.selectedTripId = $location.search().trip_id;

                     $location.search({trip_id: null, trip_date: null});
                }
                vm.getProducts(vm.filterDate);
            }
        }

        function showSelectedTrip(trip) {
            vm.getProducts({
                itinerary: trip.id
            });
        }

        function startCheckout(product, kind, gtmEvent) {
            if (!vm.haveProducts) {
                return true;
            }

            var url = '/checkout/liveaboard/';
                GTM.products('checkout_la_cart_add_trip', {
                    'currencyCode': 'USD',
                    'add': {
                        'products': [{
                            title: product.title,
                            id: product.id,
                            price: product.price,
                            brand: product.vendor,
                            category: 'Liveaboard',
                            quantity: 1
                        }]
                    }
                });

            if (gtmEvent) {
                GTM.event('checkout_la_' + gtmEvent);
            }

            url += $routeParams.location + '/' + $routeParams.slug + '/';

            if (!product && !kind) {
                $location.path(url).hash('');

                return true;
            } else if (kind) {
                $rootScope.carts = _.filter(vm.carts, {
                    sourceKind: kind
                });
                $location.path(url).hash('');

                return true;
            }

            $location.path(url).search({
                productId: product.id
            }).hash('');
        }

        function checkButtonInit () {
            if ($location.search().showRatingPopup && $location.search().showRatingPopup === 'show') {
                $timeout(function() {
                    $('#review-btn').click();

                    GTM.event('reviews_write_new_start');
                }, 150);
            } else {
                $location.search('showRatingPopup', null);
            }
        }

        function getMoreReviews () {
            vm.reviewsLoading = true;
            DiveOperator.reviews(10, vm.reviews.data.next).then(function(rating) {
                vm.reviews = rating;

                _.map(rating.data.results, function(val) {
                    vm.allReviews.push(val);
                });
                vm.reviews.data.results = vm.allReviews;

                vm.reviewsLoading = false;
            });
        }


        function setItinerary(obj) {
            //prevent loading itinerary second time. If it's already loaded.
            if (vm.itineraryInfo && vm.itineraryInfo.itinerary.slug && obj.itinerary.slug === vm.itineraryInfo.slug) {
                return true;
            }

            vm.itineraryInfo =  {
                endDate: obj.endDate,
                startDate: obj.startDate,
                slug : obj.itinerary.slug,
                id: obj.id,
                trip: obj,
                itinerary: {
                    loading: true
                }
            };

            return Request.get('shop/' + vm.info.countrySlug + '/' + $routeParams.slug + '/itineraries/' + obj.itinerary.slug + '/').then(function(res){
                vm.itineraryInfo.itinerary = res.data;
                vm.itineraryInfo.itinerary.loading = false;
                vm.itineraryInfo.itinerary.days = utils.bindItinerary(vm.itineraryInfo.itinerary.days);

                utils.bindLogistic(vm.itineraryInfo.itinerary.descriptions);

                GTM.event('page_itinerary_pageview');
            });
        }


        function setSelectedItem(item, type) {
            if (!_.isArray(vm.liveaboardFilter[type]) && type !== 'is_promotion') {
                vm.liveaboardFilter[type] = [];
            } else if (type === 'is_promotion') {
                vm.liveaboardFilter[type] = !vm.liveaboardFilter[type];
            }

            if (item) {
                var id = _.isObject(item) ? item.id : item;
                // generateFilterList(item, type);

                if (_.includes(vm.liveaboardFilter[type], id) && type != 'is_promotion' ) {
                    vm.liveaboardFilter[type] = _.without(vm.liveaboardFilter[type], id);
                    item.checked = false;
                } else if (item) {
                    item.checked = true;
                    vm.liveaboardFilter[type].push(id);
                }
            }


            if (vm.from) {
                var date = moment(vm.from);
                vm.filterDate = {
                    'month': date.locale('en').format('MMMM'),
                    'year': date.locale('en').format('YYYY'),
                    'startDate': vm.from
                };
            } else {
                vm.filterDate = {
                    'month': 'Show all',
                    'startDate': vm.fromFullDate,
                    'endDate': vm.toFullDate
                };
            }

            vm.liveaboardFilter.page = 1;

            vm.getProducts(vm.filterDate, null, vm.liveaboardFilter);
        }

        function getTrips () {
            if (vm.filterDate.year) {
                diviacLocalStorage.set('departure_date' ,vm.filterDate);
                diviacLocalStorage.set('date',[vm.filterDate.startDate,vm.filterDate.endDate])
            } else {
                diviacLocalStorage.remove('departure_date');
                diviacLocalStorage.remove('date');
            }

            if (vm.selectedTripId) {
               vm.selectedTripId = null;
            }

            vm.from = null;
            vm.getProducts(vm.filterDate, true, vm.liveaboardFilter);
        }

        function showAllTrips () {
            vm.filterDate = vm.dates[1];
            vm.from = null;
            vm.to = null;
            vm.fromFullDate = null;
            vm.toFullDate = null;
            vm.clearFilters();
        }

        function showTrips() {
            vm.filterDate = {
                'month': moment(vm.from).locale('en').format('MMMM'),
                'year': moment(vm.from).locale('en').format('YYYY'),
                'startDate': vm.from
            };

            vm.getProducts(vm.filterDate, null, vm.liveaboardFilter);
        }

        function clearFilters() {
            vm.liveaboardFilter.duration = [];
            vm.liveaboardFilter.itinerary = [];
            vm.liveaboardFilter.promotion = [];
            vm.liveaboardFilter.price = [];
            vm.liveaboardFilter.is_promotion = null;

            if (vm.from) {
                vm.from = null;
                vm.filterDate = {
                    'month': 'Show all',
                    'startDate': vm.fromFullDate,
                    'endDate': vm.toFullDate
                };
            }

            _.each(vm.promotions, function(val) {
                val.checked = false;
            });

            _.each(vm.itineraries, function(val) {
                val.checked = false;
            });

            _.each(vm.info.itinerariesLength, function(val) {
                val.checked = false;
            });

            _.each(vm.priceFilter, function(val) {
                val.checked = false;
            });

            vm.getProducts(vm.filterDate, null, vm.liveaboardFilter);
        }

        function checkPreviousTrips (trips, pass) {
            if (!trips || !vm.filterDate) {
                return false;
            }

            if (pass) {
                return true;
            }

            if (!trips.previous && vm.filterDate.year && (moment(vm.filterDate.startDate).month() > moment().month() || vm.filterDate.year != moment().year())) {
                return true;
            }

            return false;
        }

        function getItineraryLink(slug) {
            return $location.path() + slug + '/';
        }

        function setLocalStorageDate(event,date) {
            event.stopPropagation();
            diviacLocalStorage.set('departure_date', null);
            diviacLocalStorage.set('departure_date_custom', moment(date).format('YYYY-MM-DD'));
        }

        function generateSearchLink(startDate) {
            if (startDate && startDate != ""){
                return '/s/liveaboards/' + vm.info.countrySlug + '/?departure_date_custom=' + moment(startDate).format('YYYY-MM-DD');
            }
            return '/s/liveaboards/' + vm.info.countrySlug;
        }

        $rootScope.returnPrevURL = function() {
            $scope.$apply(function() {
                $location.search('');
            });
        };

        $rootScope.changeURL = function() {
            var slug = vm.itineraryInfo.slug ? vm.itineraryInfo.slug : vm.itineraryInfo.itinerary.slug;
            $location.search({
                'itinerarySlug': slug
            });
        };

        $rootScope.popupUrl = function() {
            $location.search('showRatingPopup', 'show');
        };
    });
